import http from '@/http/postcode/axios'

export default {
  show(postcode, fields=["allAddress"]) {
    return http.get(`/postcodes/${postcode}`, {
      params: {
        apiKey: process.env.VUE_APP_POSTCODE_JP_API_API_KEY,
        fields: fields.join(","),
      },
    });
  },
};
